import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  VStack,
  Center,
  Image,
  Divider,
  Box,
  useTheme,
} from '@chakra-ui/react';
import Logo from '../../assets/logos/logo_120x120.png';
import {TextG10, TextG12, TextG14} from '../typography';
import {BlueButton} from '../button';

interface SoftCheckModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
  onCancel: () => void;
}

const SoftCheckModal: React.FC<SoftCheckModalProps> = ({
  isOpen,
  onClose,
  onContinue,
  onCancel,
}) => {
  const theme = useTheme();

  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent mx={2}>
        <ModalHeader pb={0}>
          <Box mt={6}>
            <VStack spacing="18px">
              <Center>
                <Image src={Logo} width="156px" alt="Logo" />
              </Center>
              <TextG14 textAlign="center">
                We are not exactly where you are, but you can still experience these great
                neighborhoods on Walkabout.
              </TextG14>
            </VStack>
          </Box>
        </ModalHeader>
        <ModalBody>
          <VStack spacing="12px" py={8} alignItems={'start'}>
            <TextG12>&bull; North Park and Surrounding Area, San Diego</TextG12>
            <Divider />
            <TextG12>&bull; Little Italy, San Diego</TextG12>
            <Divider />
            <TextG12 alignSelf={'center'} color={theme.colors.lightestGrey}>
              More to come!
            </TextG12>
          </VStack>
          <VStack textAlign="center" spacing="14px" w="100%" mb={5}>
            <BlueButton w="100%" borderRadius="7px" onClick={onContinue}>
              Continue Sign Up
            </BlueButton>
            <TextG12
              w="100%"
              textDecoration="unset"
              onClick={onCancel}>
              Not Now
            </TextG12>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SoftCheckModal;
